import { getMetaData } from "../containers/JobPosting/jobPostingActions";
import useSingleJobSkus from "../zustandStores/singleJobSkus";
import useCreditProfileStore from "../zustandStores/userCreditProfileStore";

export const getDiscountedPrice = ({ mrp = 0, discountPercentage = 0 }) => {
  if (!discountPercentage) {
    return mrp;
  }
  const discountedPrice = discountPercentage
    ? mrp - mrp * (discountPercentage / 100)
    : mrp;
  return discountedPrice;
};

export const getDiscountedCostPerJob = ({
  noOfJobs = 0,
  discountedTotalPrice = 0
}) => {
  return discountedTotalPrice / noOfJobs;
};

export const getFormattedPrice = price => {
  const formattedPrice = price.toLocaleString("en-US");
  return formattedPrice;
};

export const formatDateWithOrdinalSuffix = (dateObj, includeYear = false) => {
  if (!dateObj) {
    return;
  }
  const day = dateObj.getDate();
  const month = dateObj.toLocaleString("default", { month: "long" });
  const year = dateObj.getFullYear();

  let dayWithSuffix;
  if (day >= 11 && day <= 13) {
    dayWithSuffix = `${day}th`;
  } else {
    const suffixes = ["th", "st", "nd", "rd"];
    const suffixIndex = day % 10 < 4 ? day % 10 : 0;
    dayWithSuffix = `${day}${suffixes[suffixIndex]}`;
  }
  if (includeYear) {
    return `${dayWithSuffix} ${month} ${year}`;
  }
  return `${dayWithSuffix} ${month}`;
};

export const getCreditFlow = queryFlow => {
  if (queryFlow === "job-purchase") {
    return "JOB_PURCHASE";
  }
  if (queryFlow === "credit-purchase") {
    return "CREDIT_PURCHASE";
  }
  if (queryFlow === "upgrade") {
    return "JOB_UPGRADE";
  }
  if (queryFlow === "offline-purchase") {
    return "OFFLINE_PURCHASE";
  }
  if (queryFlow === "job-boost") {
    return "JOB_BOOST";
  }
  if (queryFlow === "candidate-download") {
    return "CREDIT_PURCHASE"; // using the credit purchase flow for candidate download
  }
  if (queryFlow === "candidate-unlock") {
    return "CREDIT_PURCHASE"; // using the credit purchase flow for candidate download
  }
};

export const getStatusFlow = requestFlow => {
  if (requestFlow === "JOB_PURCHASE") {
    return "job-purchase";
  }
  if (requestFlow === "CREDIT_PURCHASE") {
    return "credit-purchase";
  }
  if (requestFlow === "JOB_UPGRADE") {
    return "upgrade";
  }
  if (requestFlow === "OFFLINE_PURCHASE") {
    return "offline-purchase";
  }
  if (requestFlow === "JOB_BOOST") {
    return "job-boost";
  }
  if (requestFlow === "CANDIDATE_DOWNLOAD") {
    return "candidate-download";
  }
  if (requestFlow === "CANDIDATE_UNLOCK") {
    return "candidate-unlock";
  }
};

export const getDataInMonthDateCommaYear = () => {
  const date = new Date();
  date.setDate(date.getDate() + 30); // Adding 30 days to the current date

  try {
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
  } catch (error) {
    return "";
  }
};
export const getIsSufficientCredits = async ({ jobId, categoryId, cityId }) => {
  const params = {
    ...(jobId ? { jobId } : {}),
    ...(categoryId ? { categoryId } : {}),
    ...(cityId ? { cityId } : {})
  };
  const { premiumSku = {} } = await useSingleJobSkus
    .getState()
    .fetchData(params);
  const { discountedCredits } = premiumSku;
  const { totalAvailableCredits = null } =
    useCreditProfileStore.getState().data;
  if (totalAvailableCredits === null) {
    throw "credit profile not available";
  }
  const isSufficientCredits = totalAvailableCredits >= discountedCredits;
  return isSufficientCredits;
};

export const getSpecialPriceReason = async ({ categoryId, cityId }) => {
  const data = await getMetaData();
};
